import themeSwitcher from '../../clients/theme-switcher';

interface State {
  checked: boolean;
}

export default class {
  declare state: State;
  declare switcher: ReturnType<typeof themeSwitcher>;

  onCreate() {
    this.state = {
      checked: false,
    };
  }

  onMount() {
    this.switcher = themeSwitcher(localStorage)
      .onChange((isDark: boolean) => {
        this.state.checked = isDark;
        document.documentElement.setAttribute('data-theme', isDark ? 'dark' : 'light');
      })
      .initialize();
  }

  toggleTheme() {
    this.state.checked = !this.state.checked;
    this.switcher.switchToDark(this.state.checked);
  }

  destroy() {
    this.switcher.destroy();
  }
};
